import { Explorer } from './explorer';
import { ExplorerProvider } from './explorer.provider';

export const ExplorerPage = () => (
  <ExplorerProvider>
    <Explorer />
  </ExplorerProvider>
);
